import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function H() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.H');

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [['.power-ocean-home-H .img-box', { y: -240 }, { y: 0 }]],
            triggerElement: '.power-ocean-home-H',
            triggerHook: 1,
            offset: 240,
            duration: '50%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`power-ocean-home-H ${styles['power-ocean-home-H']}`}>
            <div className="pc">
                <div className="text-box">
                    <div className="text-inner">
                        <div className="left">
                            <p className="sub-title">{t('label')}</p>
                            <h2 className="title">{t('title')}</h2>
                        </div>
                        <p className="right">{t('desc')}</p>
                    </div>
                </div>
                <div className="img-box">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1768965050153/8.jpg" alt={t('title')} />
                </div>
            </div>
            <div className="h5">
                <div className="text-box">
                    <div className="left">
                        <p className="sub-title">{t('label')}</p>
                        <h2 className="title">{t('title')}</h2>
                    </div>
                    <p className="right">{t('desc')}</p>
                </div>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1768965049980/8-h5.jpg"
                        alt={t`We take reliability seriously, for every single battery`}
                    />
                </div>
            </div>
        </div>
    );
}
